module.exports = __webpack_public_path__ + "static/media/logo_mais_vendas.15e6c0ad.png";